import { useEffect, useState } from 'react'
import { LaunchDarkly } from '@truepill/tpos-types'
import { useClient, useFlags } from 'providers/LaunchDarklyProvider'

interface FeatureFlagsState {
  useRxClarificationStatus?: boolean
}

const initialFlagsState: FeatureFlagsState = {
  useRxClarificationStatus: false,
}

export function useInvalidRxStatusFeatureFlag(
  customerLegacyId: number | null | undefined,
): FeatureFlagsState & { loading: boolean } {
  const defaultCustomerLegacyId = '0'
  const { client: ldClient } = useClient()
  const [flags, setFlags] = useState<FeatureFlagsState>(initialFlagsState)
  const [loading, setLoading] = useState(true)

  const { useRxClarificationStatus } = useFlags({
    useRxClarificationStatus: LaunchDarkly.FeatureFlags.USE_RX_CLARIFICATION_STATUS,
  })

  useEffect(() => {
    if (!ldClient) return
    setLoading(true)
    const updateFlags = () => {
      setFlags({
        useRxClarificationStatus,
      })
      setLoading(false)
    }

    ldClient.identify(
      {
        key: customerLegacyId?.toString() ?? defaultCustomerLegacyId,
      },
      undefined,
      updateFlags,
    )
  }, [ldClient, customerLegacyId, useRxClarificationStatus])

  return { ...flags, loading }
}
